import { useEffect, useState } from "react";
import CallAPI from "../api";



export default function useHome(view_user_list,view_employee_list){
    const [user,setuser]=useState();
    const [employee,setemployee]=useState();
    const [loading,setloading]=useState(false);
    useEffect(()=>{
     if(view_employee_list!=undefined && view_employee_list!=undefined){
        setloading(true);
        async function fetch(){
       try {
          if(view_employee_list){
           const res=await CallAPI("employee/analysis");
           setemployee(res.data);
          }
          if(view_user_list){
           const res=await CallAPI("user/analysis");
           setuser(res.data);
          }
       } catch (error) {
           console.log(error);
       }
       setloading(false);
        }
        fetch();
     }
    },[view_user_list,view_employee_list])

    return {user,employee};
}